import * as React from 'react';

import PropTypes from 'prop-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { isSuperuser } from 'js/lib/user';

import getCurrentSocialProfile from 'pages/open-course/common/models/currentSocialProfile';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { ProfileArea } from 'bundles/discussions';
import CommentPaginationContainer from 'bundles/discussions/components/repliesList/CommentPaginationContainer';
import ForumsConnectedReplyCMLInput from 'bundles/discussions/components/repliesList/ForumsConnectedReplyCMLInput';
import ReplyListItem from 'bundles/discussions/components/repliesList/ReplyListItem';
import { replyPropType } from 'bundles/discussions/lib/propTypes';
import { formatReplyLegendId } from 'bundles/discussions/utils/threadUtils';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ReplyContainer';

class ReplyListItemContainer extends React.Component {
  static propTypes = {
    reply: replyPropType.isRequired,
    savingState: PropTypes.string,
    answerId: PropTypes.string,
    commentId: PropTypes.string,
    isClosed: PropTypes.bool,
    isHighlighted: PropTypes.bool,
    comments: PropTypes.array,
    isQuestionLoaded: PropTypes.bool,
    forumLink: PropTypes.string,
    forumType: PropTypes.string,
    question: PropTypes.object,
    showJumpLink: PropTypes.bool,
    collapseCommentsByDefault: PropTypes.bool,
    hideUndoDelete: PropTypes.bool,
    fetchAnswerPosition: PropTypes.func,
    isFocused: PropTypes.bool,
    onDeleteClick: PropTypes.func,
    onDeleteSuccess: PropTypes.func,
    isReadOnlyAfterSessionEnd: PropTypes.bool,
  };

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);

    this.state = {
      showComments: props.reply.childAnswerCount > 0 && !props.collapseCommentsByDefault,
    };
  }

  // if user has posted a new reply or there is a new comment,
  // show the comments even if the user has hidden them.
  componentWillReceiveProps(nextProps: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'comments' does not exist on type 'Readon... Remove this comment to see the full error message
    if (!this.props.comments || !nextProps.comments) {
      return;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'comments' does not exist on type 'Readon... Remove this comment to see the full error message
    if (this.props.comments.length < nextProps.comments.length) {
      this.setState({ showComments: true });
    }
  }

  toggleComments = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showComments' does not exist on type 'Re... Remove this comment to see the full error message
    this.setState((prevState) => ({ showComments: !prevState.showComments }));
  };

  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
      reply,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerId' does not exist on type 'Readon... Remove this comment to see the full error message
      answerId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentId' does not exist on type 'Reado... Remove this comment to see the full error message
      commentId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isClosed' does not exist on type 'Readon... Remove this comment to see the full error message
      isClosed,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isHighlighted' does not exist on type 'R... Remove this comment to see the full error message
      isHighlighted,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type 'Rea... Remove this comment to see the full error message
      savingState,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showJumpLink' does not exist on type 'Re... Remove this comment to see the full error message
      showJumpLink,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumLink' does not exist on type 'Reado... Remove this comment to see the full error message
      forumLink,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
      forumType,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
      question,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isQuestionLoaded' does not exist on type... Remove this comment to see the full error message
      isQuestionLoaded,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideUndoDelete' does not exist on type '... Remove this comment to see the full error message
      hideUndoDelete,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fetchAnswerPosition' does not exist on t... Remove this comment to see the full error message
      fetchAnswerPosition,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isFocused' does not exist on t... Remove this comment to see the full error message
      isFocused,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteClick' does not exist on t... Remove this comment to see the full error message
      onDeleteClick,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteSuccess' does not exist on t... Remove this comment to see the full error message
      onDeleteSuccess,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isReadOnlyAfterSessionEnd' does not exist on t... Remove this comment to see the full error message
      isReadOnlyAfterSessionEnd,
    } = this.props;

    // TODO: Delete animation
    if (reply.hide) {
      return null;
    }

    const currentSocialProfile = getCurrentSocialProfile();

    return (
      <ReplyListItem
        reply={reply}
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'showComments' does not exist on type 'Re... Remove this comment to see the full error message
        commentsEnabled={this.state.showComments}
        toggleComments={this.toggleComments}
        answerId={answerId}
        commentId={commentId}
        commentCount={reply.childAnswerCount || 0}
        className="rc-ReplyContainer"
        isHighlighted={isHighlighted}
        isQuestionLoaded={isQuestionLoaded}
        forumLink={forumLink}
        forumType={forumType}
        showJumpLink={showJumpLink}
        hideUndoDelete={hideUndoDelete}
        fetchAnswerPosition={fetchAnswerPosition}
        isFocused={isFocused}
        onDeleteClick={onDeleteClick}
        onDeleteSuccess={onDeleteSuccess}
        isReadOnlyAfterSessionEnd={isReadOnlyAfterSessionEnd}
      >
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'showComments' does not exist on type 'Re... Remove this comment to see the full error message */}
        {this.state.showComments && (
          <div>
            <CommentPaginationContainer
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ reply: any; answerId: any; commentId: any;... Remove this comment to see the full error message
              reply={reply}
              answerId={answerId}
              commentId={commentId}
              forumLink={forumLink}
              forumType={forumType}
              isQuestionLoaded={isQuestionLoaded}
              onDeleteClick={onDeleteClick}
              onDeleteSuccess={onDeleteSuccess}
              isReadOnlyAfterSessionEnd={isReadOnlyAfterSessionEnd}
            />

            {!isClosed && !isReadOnlyAfterSessionEnd && (
              <div className="comment-input horizontal-box">
                <ProfileArea
                  externalUserId={currentSocialProfile.get('externalUserId')}
                  fullName={currentSocialProfile.get('fullName')}
                  profileImageUrl={currentSocialProfile.getProfileImageUrl()}
                />
                <ForumsConnectedReplyCMLInput
                  forumType={forumType}
                  question={question}
                  parentPost={reply}
                  ariaLabel={
                    reply?.creator?.fullName
                      ? _t('Reply to #{parentPostCreator} ', { parentPostCreator: reply.creator?.fullName })
                      : _t('Reply to post')
                  }
                  ariaDescribedBy={formatReplyLegendId(reply)}
                  savingState={savingState}
                />
              </div>
            )}
          </div>
        )}
      </ReplyListItem>
    );
  }
}

export default connectToStores(
  ReplyListItemContainer,
  ['ThreadDetailsStore', 'ThreadSettingsStore', 'CourseMembershipStore'],
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type '{}'.
  ({ ThreadDetailsStore, ThreadSettingsStore, CourseMembershipStore }, { reply }) => {
    return {
      question: ThreadDetailsStore.getQuestion(reply.questionId),
      comments: ThreadDetailsStore.getLoadedComments(reply.topLevelForumAnswerId),
      isClosed: ThreadSettingsStore.isClosed(),
      isHighlighted: ThreadDetailsStore.isHighlighted(reply),
      savingState: ThreadDetailsStore.savingStates[reply.id],
      hideUndoDelete: CourseMembershipStore.getCourseRole() === 'LEARNER' && !isSuperuser(),
    };
  }
);
